import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {User} from 'main/stores/users';
import moment from 'moment';

class Note extends DomainObject {
  content = '';
  createdAt;
  updatedAt;

  _relations = {
    _dates: ['createdAt', 'updatedAt'],
    author: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      content: observable,
      createdAt: observable,
      updatedAt: observable,
      createdTimeAgo: computed,
      updatedTimeAgo: computed,
      hasBeenUpdated: computed
    });

    this.merge(other);
  }

  get createdTimeAgo() {
    return moment(this.createdAt).fromNow();
  }

  get updatedTimeAgo() {
    return moment(this.updatedAt).fromNow();
  }

  get hasBeenUpdated() {
    return !moment(this.updatedAt).isSame(this.createdAt);
  }
}

export default Note;
